import { useEffect, useState } from "react";

import "./BrandCarousel.css";

// Keep the JavaScript cycle and the CSS transition in step: the hold gives a
// logo time to be read, and the transition covers the hand-off.
const CYCLE_MS = 3800;
const TRANSITION_MS = 800;

const BRANDS = [
  { name: "Pinnacle Mountain Homes", src: "/brands/pmh-logo.png" },
  { name: "Collective Architecture", src: "/brands/ca-logo.png" },
  { name: "Collective Design", src: "/brands/cd-logo.png" },
];

export default function BrandCarousel() {
  const [slide, setSlide] = useState({ current: 0, previous: -1, cycle: 0 });
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    const sync = () => setReduceMotion(query.matches);
    sync();
    query.addEventListener?.("change", sync);
    return () => query.removeEventListener?.("change", sync);
  }, []);

  useEffect(() => {
    if (reduceMotion) return;
    const timer = window.setInterval(() => {
      setSlide((state) => ({
        current: (state.current + 1) % BRANDS.length,
        previous: state.current,
        cycle: state.cycle + 1,
      }));
    }, CYCLE_MS);
    return () => window.clearInterval(timer);
  }, [reduceMotion]);

  return (
    <div className="brand-carousel">
      {reduceMotion ? (
        <div className="brand-carousel__row">
          {BRANDS.map((brand) => (
            <img key={brand.src} src={brand.src} alt={brand.name} />
          ))}
        </div>
      ) : (
        <div className="brand-carousel__stage">
          {slide.previous >= 0 && (
            <div
              key={`leave-${slide.cycle}`}
              className="brand-carousel__slide brand-carousel__slide--leave"
              style={{ animationDuration: `${TRANSITION_MS}ms` }}
              aria-hidden="true"
            >
              <img src={BRANDS[slide.previous].src} alt="" />
            </div>
          )}
          <div
            key={`enter-${slide.cycle}`}
            className="brand-carousel__slide brand-carousel__slide--enter"
            style={{ animationDuration: `${TRANSITION_MS}ms` }}
          >
            <img src={BRANDS[slide.current].src} alt={BRANDS[slide.current].name} />
          </div>
        </div>
      )}
    </div>
  );
}
